var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mk-content',[_c('b-loading',{attrs:{"active":_vm.isLoading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }